//import { element } from 'protractor';
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UIControlTyp } from 'src/app/core/models/UIControlTyp';
import { AzurePersonRoles } from 'src/app/core/models/AzurePersonRoles';
import { AzurePerson } from 'src/app/core/models/AzurePerson';

@Component({
  standalone: false,
  selector: 'fdb-project-manager',
  templateUrl: './project-manager.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./project-manager.component.scss']
})

export class ProjectManagerComponent {

  /** Hiermit können Sie bestimmen ob eine DropDown Liste angezeigt wird oder eine MultiSelect Eingabefeld */
  @Input() uiController: UIControlTyp = UIControlTyp.DropDownList;
  @Input() values: string | number | number[];
  roles: AzurePersonRoles = AzurePersonRoles.Any; // Dies muss auf Any stehen, und nicht auf ProjectLeader
  @Output() valuesChange = new EventEmitter();
  @Output() objectChange = new EventEmitter<AzurePerson>();

  constructor() {
    // Dies muss auf Any stehen, und nicht auf ProjectLeader, damit in der Dropdownliste ALLE
    // Personen auftauchen und nicht nur die, die bereits in einem anderen Projekt als
    // Projektleiter tätig sind.
    this.roles = AzurePersonRoles.Any;
  }

  onChange(newValue: any) {
    this.values = newValue;
    this.valuesChange.emit(this.values);
  }

  objectChanged(newValue: any) {
    this.objectChange.emit(newValue);
  }
}
